// Module
var code = "<!-- ko foreach: Items --> <div class=\"multi-select-item\" data-bind=\"css: {active: IsSelected, disabled: IsSelected }\"> <a data-bind=\"text: $parent.FormatValue(Label), click: $parent.SelectItem.bind($parent, $data)\" href=\"javascript:;\"> </a> </div> <!-- /ko -->";
// Exports
export default code;